import React, { useState, useEffect } from 'react';
import { createBrowserRouter, RouterProvider, Link as RouterLink, Outlet } from 'react-router-dom';
import { Image, Panel, Persona, PersonaSize, Callout, Text, Link } from '@fluentui/react';
import { HomeMore24Regular, ChevronLeft24Regular, ChevronRight24Regular } from '@fluentui/react-icons';
import { Carousel, CarouselCard, CarouselNav, CarouselNavContainer, CarouselNavButton, CarouselViewport, CarouselSlider, CarouselAutoplayButton} from "@fluentui/react-carousel";
import { DefaultButton, PrimaryButton, IconButton  } from '@fluentui/react/lib/Button';
import { useId } from '@fluentui/react-hooks';
import { FontIcon } from '@fluentui/react/lib/Icon';
// Import the initializer
import { initializeIcons } from '@fluentui/react/lib/Icons'; 
import Home from './Home';
import OrderManagement from './OrderManagement';
import DemandManagement from './DemandManagement';
import InventoryManagement from './InventoryManagement';
import DataManagement from './DataManagement';
import Locations from './Locations';
import Careers from './Careers';
import CaseStudies from './CaseStudies';
import HealthXM from './HealthXM';
import AboutUs from './AboutUs';
import DineXM from './DineXM';

const CarouselItem = ({items}: any) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const next = () => setCurrentIndex((currentIndex + 1) % items.length);
  const prev = () => setCurrentIndex((currentIndex - 1 + items.length) % items.length);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
        {/*<p style={{ textAlign: 'center', fontSize: '14px' }}>{items[currentIndex]}</p>*/}
        <div className="card-grey">         
           <ul className="card-list-grey">
            {
            items.map((item: any, idx: any) => (
              <li key={idx}>{item}</li>
            ))
            }
           </ul>
        {/*<a href="#" className="card-btn-grey">More..</a>*/}
       </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', borderTop: '1px solid #e1e1e1' }}>
       {
        /*<button onClick={prev} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '5px' }}>
          <ChevronLeft24Regular />
        </button>
        <div style={{ display: 'flex', gap: '6px' }}>
          {items.map((_: any, idx: any) => (
            <div
              key={idx}
              style={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                background: idx === currentIndex ? '#0078d4' : '#d1d1d1'
              }}
            />
          ))}
        </div>
        <button onClick={next} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '5px' }}>
          <ChevronRight24Regular />
        </button>*/
        }
      </div>
    </div>
  );
};

interface ImageItem {
  id: number;
  src: string;
  alt: string;
}


const RootLayout = () => {
  initializeIcons();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [images, setImages] = React.useState<ImageItem[]>([{id: 1, src: "esdxg.png", alt: "Digital SCM"}, { id: 2, src: 'healthxm.png', alt: 'SCM Program' }, {id: 3, src: "scmstrategy.png", alt: "SCM Strategy"}, {id: 4, src: "scmservices.png", alt: "SCM Services"}]);
  
  const [isAutoplay, setIsAutoplay] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Handle the autoplay interval
  useEffect(() => {
    if (!isAutoplay) return;

    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % 5); // 5 represents the total number of slides
    }, 3000); // Transitions every 3 seconds

    return () => clearInterval(intervalId); // Cleanup interval on unmount or state change
  }, [isAutoplay]);

  // Handle autoplay button click
  const handleAutoplayToggle = () => {
    setIsAutoplay((prev) => !prev);
  };

  const listData = {"ESDXG_Services": ["eSDXG helps businesses to transform its Supply Chain processes using intelligent and autonomous systems. Assist organizations in complex assessments, enable effective decision making and drive outcomes. HealthXM is a program which serve organizations in Health care industry for transformations in R&D, Sales and Procurement functions."],
                    "HealthXM_Services": ["Assisting industry players to streamline their commercial operations.", "Works with Pharma & Life science companies and leverage platform features in studies and trials to improve efficiency, timelines and drive innovation.", "Improve patient engagement and experience through insightful actions in both clinical diagnostics and therapeutics", "Enabling sales across the value chain.", "Intelligent inventory planning and procurement."],
                    "DineXM_Services": ["Drive partnerships for better culinary and dining experiences.", "Improve customer engagement through insightful actions on quality, affordability and accessibility.", "Develop Technology CoEs for dining operations and food processing.", "Enabling sales across the value chain.", "Intelligent inventory planning and procurement."],
                    "Smart_Factories_Program": ["Implement smart manufacturing technologies to improve efficiency and quality.", "Use data analytics to optimize production processes and reduce waste.", "Integrate IoT devices for real-time monitoring and predictive maintenance.", "Enhance workforce skills through training and development programs."],
                    "Smart_Spaces_Program": ["Design and implement smart building solutions for energy efficiency and comfort.", "Use sensors and automation to optimize space utilization and reduce costs.", "Integrate security and access control systems for enhanced safety.", "Provide personalized experiences for occupants through smart technologies."],
                    "Demand_Management": ["Data driven demand planning and assisted execution.", "Goal based marketing with a focus on budget, branding and Marketing ROI.", "Automated knowledge systems enables quick selection of right audience, media and channel mix.", "Engage expert partners where ever required.", "Alerts on competition gaps and customer experience performance reviews.", "Support fast realizations by coordinating till product/service delivery."], 
                    "Order_Management": ["Modern businesses with sophisticated supply chains demand uptodate and intelligent information while trading.", "System will assist to reduce effort in RFI process while purchasing / selling products and services.", "Automated RFQ process including selection of suppliers and distributors aligned to your business needs.", "Assistance on sales and procurement execution.", "Recommend strategic partnerships which can bring capabilities and capacity with reduced capex and opex."], 
                    "Inventory_Management": ["Automated stock planning and control, whether it can be raw materials, work in progress, finished goods and services.", "Manage information on transporatation and logistics facilities, capacities and availability across markets.", "Coordinate the the inventory movements across markets by engaging the right transportation and logistic partners.", "Assistance on executing different types of inventories.", "Notifications on inventory levels and performance."], 
                    }
  const labelId = useId('callout-label');
  const descriptionId = useId('callout-description');
  const targetId = useId('callout-target');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', fontFamily: 'Segoe UI, sans-serif' }}>
      {/* Header */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',          
        background: 'linear-gradient(90deg, rgba(42, 87, 155, 1) 0%, rgba(87, 199, 133, 1) 100%, rgba(237, 224, 83, 1) 100%)',
        color: 'white',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <div style={{ 
            width: '300px', 
            height: '100px', 
            background: 'transparent', 
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '48px',
            fontWeight: 'bold',
            color: '#CCCCCC',
            paddingLeft: '10px'       
          }}>
             <Image src="logo.png" alt="Logo" width="60%" height="100%" />eSDXG
          </div>          
        </div>
        <div style={{ display: 'flex', gap: '15px', alignItems: 'right' }}>
            <span id={targetId}><FontIcon aria-label="Announcement" iconName="Info" className={"info-icon"} /></span>
                <Callout
          className={"callout"}
          ariaLabelledBy={labelId}
          ariaDescribedBy={descriptionId}
          role="dialog"
          gapSpace={0}  
          target={`#${targetId}`}        
          setInitialFocus
        >
          {/*<Text as="h1" block variant="xLarge" className={"callout-title"} id={labelId}>
            Operations start soon
          </Text>
          <Text block variant="small" id={descriptionId} className={"callout-content"}>
            First phase platform subscriptions and associated services will be rolled out to selected customers. Please send enquiries to services@esdxg.com
          </Text>*/
          } 
          <Text block variant="small" id={descriptionId} className={"callout-content"}>
            Please send enquiries to services@esdxg.com<br/>
            Call: +91-8078414000
          </Text>         
        </Callout>
          </div>       
      </div>
      {/* Body */}
      <div style={{ 
        flex: 1, 
        display: 'flex', 
        flexWrap: 'wrap', 
        padding: '20px',
        gap: '20px',
        background: '#f5f5f5',
        flexDirection: 'row'
      }}>       

        <div key="Focus" style={{ 
            flex: '1 1 calc(100% - 20px)',
            minWidth: '400px',
            height: '250px',
            background: 'white',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            overflow: 'hidden'
          }}>            
            <div style={{ height: 'calc(100% - 50px)' }}>              
               <Carousel activeIndex={currentIndex} onActiveIndexChange={(e, data) => setCurrentIndex(data.index)}>                                 
                <CarouselViewport >
                <CarouselSlider onMouseEnter={handleAutoplayToggle} onMouseLeave={handleAutoplayToggle}>
                  {images.map((image) => (
                    <CarouselCard key={image.id}>
                      <Image width='100%' height='200px' src={image.src} alt={image.alt} />
                    </CarouselCard>
                  ))}
                </CarouselSlider>
                </CarouselViewport>
                <div style={{width: '100%', textAlign: 'center', paddingTop: '10px'}}>
                     <IconButton iconProps={{iconName: isAutoplay ? 'Pause' : 'Play'}} onClick={handleAutoplayToggle} title={isAutoplay ? 'Pause' : 'Play'} ariaLabel={isAutoplay ? 'Pause' : 'Play'}></IconButton>
                </div>
                {/*
                 <PrimaryButton 
            onClick={handleAutoplayToggle} 
          >
            {isAutoplay ? 'Pause Autoplay' : 'Start Autoplay'}
          </PrimaryButton> /*}
                {/* Navigation controls (optional)    
                <CarouselNavContainer next={{ 'aria-label': '>' }} prev={{ 'aria-label': '<' }}  autoplay={{ 'aria-label': 'auto' }}>                  
                  <CarouselNav>{index => <CarouselNavButton aria-label={`${index}`} />}</CarouselNav> 
                </CarouselNavContainer>
                */}                             
              </Carousel>
            </div>
        </div>
        {/* Outlet renders the matched child route component */}
        <Outlet />  
      </div>
      {/* Footer */}
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        padding: '20px', 
        background: 'darkblue', 
        color: 'white',
        fontSize: '14px'
      }}>
        <p style={{ margin: 0 }}>© 2026 eSDXG LLP. All rights reserved.</p>
      </div>
    </div>
  );
};

// 3. Configure the Router and Nest Routes
const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {index: true, element: <Home />},
      { path: 'demandmanagement', element: <DemandManagement /> },
      { path: 'ordermanagement', element: <OrderManagement /> },
      { path: 'inventorymanagement', element: <InventoryManagement />},
      { path: 'datamanagement', element: <DataManagement />},
      { path: 'careers', element: <Careers /> }, 
      { path: 'casestudies', element: <CaseStudies />},
      { path: 'healthxm', element: <HealthXM />}, 
      { path: 'dinexm', element: <DineXM />}, 
      { path: 'locations', element: <Locations /> },
      { path: 'aboutus', element: <AboutUs /> },
    ],
  },
]);

const App = () => {  
  return <RouterProvider router={router}/>;
}
export default App;